import React, { useCallback, useMemo, useRef } from 'react';

import { Tooltip } from 'src/app/components/lib/tooltip';
import { useListWithMaxHeight } from 'src/app/hooks/use-list-with-max-height';

import { FilterTypeBadge } from './filter-type-badge';
import { StyledFilterList, TooltipContents, TooltipIndicatorText } from './styled';

import type { FilterButtonProps } from './button';
import type { TextGetter } from 'src/app/hooks/use-list-with-max-height';

export function FilterList({ filterType, selectedOptions }: Pick<FilterButtonProps, 'filterType' | 'selectedOptions'>) {
  const ref = useRef<HTMLParagraphElement>(null);

  const getText = useCallback<TextGetter>(
    ({ displayedOptions, hiddenOptions }) =>
      `  ${filterType}  ${displayedOptions.join(', ')} + ${hiddenOptions.length} more`,
    [filterType]
  );

  const options = useMemo(() => selectedOptions ?? [], [selectedOptions]);

  const { displayedOptions, hiddenOptions } = useListWithMaxHeight({
    font: 'var(--font-extra-small-12pt-normal)',
    getText,
    maxListHeight: 36,
    ref,
    options,
  });

  const numberOfHiddenOptions = hiddenOptions.length ?? 0;

  return (
    <StyledFilterList ref={ref}>
      <FilterTypeBadge filterType={filterType} />
      {displayedOptions.join(', ')}
      {numberOfHiddenOptions > 0 && (
        <>
          {' + '}
          <Tooltip title={<TooltipContents>{hiddenOptions.join(', ')}</TooltipContents>}>
            <TooltipIndicatorText>{numberOfHiddenOptions} more</TooltipIndicatorText>
          </Tooltip>
        </>
      )}
    </StyledFilterList>
  );
}
